import React from 'react'
import { useFormContext } from '@/state/main-form/reducer'
import { FormDropdown } from './dropdown'
import ExternalLink from './external-link'
import { FormActions } from './form-actions'
import { CompleteFormActionButton } from './form-actions/complete-button'
import style from './form-control-panel.module.sass'
import { FormValidation } from './form-validation-sidebar'
import { LlmButton } from './llm/button'
import { ChatInterface } from './llm/chat-interface'
import PdfSection from './pdf-section'
import QuickLinks from './quick-links'
import { SavingIndicator } from './saving-indicator'
import { SubmitButtonDeprecated } from './submit-button-deprecated'

type Props = {
	chatOpen: boolean
	setChatOpen: (chatOpen: boolean) => void
}

export const FormControlPanel = ({ chatOpen = false, setChatOpen }: Props) => {
	const formContext = useFormContext()

	if (formContext.publicForm?.code) {
		return (
			<>
				<div className={style.buttonRow}>
					{formContext.form.hidePublicLinkSubmitButton ?
						null
					: formContext.publicForm.formAction ?
						<CompleteFormActionButton formAction={formContext.publicForm.formAction} />
					:	<SubmitButtonDeprecated />}
					<SavingIndicator />
				</div>
				<FormValidation />
			</>
		)
	} else if (chatOpen) {
		return <ChatInterface setChatOpen={setChatOpen} />
	} else {
		return (
			<>
				{!formContext.record.archived && (
					<div className={style.buttonRow}>
						<SavingIndicator />
						<FormDropdown />
					</div>
				)}

				{formContext.form.allowPublicLinks && (
					<div>
						<ExternalLink readOnly={formContext.record.archived} />
					</div>
				)}

				<FormValidation />

				<FormActions />

				<PdfSection
					recordId={formContext.record.id}
					formId={formContext.form.id}
					readOnly={formContext.record.archived}
				/>

				<QuickLinks formId={formContext.form.id} />

				<LlmButton setChatOpen={setChatOpen} />
			</>
		)
	}
}
